import { HerbicideSummaryDescription } from '../../components/ToxicExposureSummary';
import {
  herbicideSummaryPageTitle,
  titleWithSubtitle,
} from '../../content/toxicExposure';

export const uiSchema = {
  'ui:title': titleWithSubtitle(herbicideSummaryPageTitle, 'Summary'),
  'ui:description': HerbicideSummaryDescription,
};

export const schema = {
  type: 'object',
  properties: {},
};
